import { FetchApi } from './fetch-api'
import { AxiosApi } from './axios-api'
import { isBrowser } from '../utils'

export function apiFactory(platform: string, publicApiKey: string, acceptLanguage?: string, debug = false, apiUrl?: string) {
  if (isBrowser()) {
    return new FetchApi(platform, publicApiKey, acceptLanguage, debug, apiUrl)
  }

  return new AxiosApi(platform, publicApiKey, acceptLanguage, debug, apiUrl)
}
